<template>
  <pict
    class="connected-image__image m-auto s:max-w-auto m:max-w-xs l:max-w-auto"
    block-name="connected-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "../images/Running_Out.png"
import imageL2x from "../images/Running_Out@2x.png"
import imageM from "../images/Running_Out_m.png"
import imageM2x from "../images/Running_Out_m@2x.png"
import imageS from "../images/Running_Out_s.png"
import imageS2x from "../images/Running_Out_s@2x.png"
export default {
  name: "ConnectedImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageM,
            srcset: {
              "2x": imageM2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Illustration of a person  with a short hairstyle, wearing a blue short-sleeved shirt with yellow stripes, and air pods sending a digital invitation represented as a paper airplane, flying from his tablet with dotted line trailing behind as a gift to another person wearing a yellow short-sleeved shirt, big blue headphones and a bun in their hair. The invitation arrives to their tablet as a blue gift with yellow ribbon popping up out of the screen."
      },
      de: {
        alt: "Die Illustration zeigt zwei Personen, die interagieren: Die erste Person hat kurze Haare, trägt ein blaues T-Shirt und hält ein Tablet, von dem aus eine Einladung in Form eines Papierflugzeugs zur zweiten Person fliegt, die einen Dutt und Kopfhörer trägt und ebenfalls ein Tablet hält. Die Einladung kommt in Form eines glau-gelben Geschenks auf ihrem Tablet an."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.connected-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
